import { Component, Inject,  OnDestroy } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA,MatDialogRef} from '@angular/material/dialog';
import {DialogData} from "../../core/interfaces/dialog-data.interface";
import {UserService} from '../../core/services/user.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {OwnerData} from '../../core/models/account/owner-data.model';
import {AccountData} from '../../core/models/account/account-data.model';


@Component({
  selector: 'app-idf-select',
  templateUrl: './idf-select.component.html',
  styleUrls: ['./idf-select.component.scss']
})
export class IdfSelectComponent implements OnDestroy {
  currentlyDisplayedIdf: string = '9999910'
  idfsDetails: any;
  isSelect = false;
  public ngUnsubscribe$ = new Subject<any>();



  constructor(
      public dialog: MatDialog,
      @Inject(UserService) public userService: UserService,


  ) {
    this.idfsDetails =  [{
          name: 'Testapotheke',
          street: 'Probestrasse 5',
          zipCode: '68219',
          city: 'Mannheim',
          email: 'info@testapotheke.de',
          phone: '0621 1234567',
          fax: '0621 1234568',
          idf: '9999910'
        }
      ];
  }

  openIdfSelect() {
    const dialogRef = this.dialog.open(IdfSelectDialog, {
      data: {
        idfs: this.idfsDetails,
        currentIdf: this.currentlyDisplayedIdf,
      },
      disableClose: true,
      panelClass: 'idf-select-dialog',
      closeOnNavigation: true
    });
  }

  setIdf(value: any) {
    
  }

    /**
     * Unsubscribe from all subscriptions.
     */
    ngOnDestroy() {
      this.ngUnsubscribe$.next('');
      this.ngUnsubscribe$.complete();
    }


}

@Component({
  selector: 'idf-select-dialog',
  templateUrl: 'idf-select-dialog.html',
  styleUrls: ['./idf-select-dialog.scss']
})
export class IdfSelectDialog {

  selectedIdf: any;
  constructor(public dialogRef: MatDialogRef<IdfSelectDialog>,
              // @Inject(UserService) public userService: UserService,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    console.log(data);
  }

  closeDialog() {
    this.dialogRef.close(this.selectedIdf);
  }
}
